import { useCallback } from 'react';
import { useMotionValue } from 'framer-motion';

/**
 * Pointer position inside the hovered element, as motion values, for a light
 * that follows the cursor. Touch input is ignored.
 */
const useSpotlight = () => {
  const pointerX = useMotionValue(-1000);
  const pointerY = useMotionValue(-1000);

  const onPointerMove = useCallback((event) => {
    if (event.pointerType === 'touch') return;
    const rect = event.currentTarget.getBoundingClientRect();
    pointerX.set(event.clientX - rect.left);
    pointerY.set(event.clientY - rect.top);
  }, [pointerX, pointerY]);

  return { pointerX, pointerY, onPointerMove };
};

export default useSpotlight;
